// extracted by mini-css-extract-plugin
export default {"message":"RevokePopup_message__leJJw","confirmButton":"RevokePopup_confirmButton__2MqOp"};